import { render, staticRenderFns } from "./SwitchBar.vue?vue&type=template&id=3df3dca2&scoped=true&"
import script from "./SwitchBar.vue?vue&type=script&lang=js&"
export * from "./SwitchBar.vue?vue&type=script&lang=js&"
import style0 from "./SwitchBar.vue?vue&type=style&index=0&id=3df3dca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df3dca2",
  null
  
)

export default component.exports